module.exports = __webpack_public_path__ + "spine/building_celebration_6x6.json?6de87c47cfda5896a2e8a2a8a2754eae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/building_construction/building_celebration_6x6.json
// module id = 1754
// module chunks = 3